import EpisodeListRow from "./EpisodeListRow";
import LiveListRow from "./LiveListRow";
import TVShowListRow from "./TVShowListRow";
import ChannelListRow from "./ChannelListRow";
import AdvertListRow from "./AdvertListRow";
export default function ListRow(props) {
  const { item } = props;
  return (
    <>
      {item.__typename === "EpisodeMeta" && <EpisodeListRow {...props} />}
      {item.__typename === "LiveMeta" && <LiveListRow {...props} />}
      {item.__typename === "TVShowMeta" && <TVShowListRow {...props} />}
      {item.__typename === "ChannelMeta" && <ChannelListRow {...props} />}
      {item.__typename === "Advert" && <AdvertListRow {...props} />}
    </>
  );
}
